/**
 * Leitor de flag. Recebe o valor padrão da chave e pode devolver qualquer coisa: o
 * resolvedor só aceita booleano e trata o resto como ausência de valor.
 */
export type FlagReader = (key: string, defaultValue: boolean) => unknown;

export interface MigrationDefaults {
  readonly moduleDefault: boolean;
  readonly killSwitchDefault: boolean;
}

/** Chave do interruptor global; o slug 'kill-switch' é reservado no registro de rotas. */
export const KILL_SWITCH_KEY = 'react-ui-kill-switch';

/** Decide se o módulo é servido pela página React. Nunca lança. */
export function resolveModuleMigration(
  flagKey: string,
  readFlag: FlagReader,
  defaults: MigrationDefaults,
): boolean {
  // O kill switch vem primeiro e, ligado, encerra a decisão sem consultar o módulo.
  if (readBoolean(readFlag, KILL_SWITCH_KEY, defaults.killSwitchDefault)) {
    return false;
  }
  return readBoolean(readFlag, flagKey, defaults.moduleDefault);
}

function readBoolean(readFlag: FlagReader, key: string, defaultValue: boolean): boolean {
  try {
    const value = readFlag(key, defaultValue);
    // Valor não booleano (string, número, objeto, ausente) não é uma resposta válida da
    // flag; vale o default da chave, como se o cliente não tivesse respondido.
    return typeof value === 'boolean' ? value : defaultValue;
  } catch {
    // Uma falha do leitor não pode derrubar o render da rota; vale o default da chave.
    return defaultValue;
  }
}
